import Vue from 'vue';
import Router from 'vue-router';
import Login from '../views/Login.vue';
import CreateNewVoucherView from '../components/voucher/CreateNewVoucherView.vue';

import VendorManagement from '../components/vendor/VendorManagement.vue';
import OpenVouchers from '../components/voucher/OpenVouchers.vue';
import VoucherTracking from '../components/voucher/VoucherTracking.vue';
import VoucherArchive from '../components/voucher/VoucherArchive.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'openvouchers' }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layoutPlain: true,
    },
  },
  {
    path: '/voucher-erstellen',
    name: 'createvoucher',
    component: CreateNewVoucherView
  },
  {
    path: '/vendormanagement',
    name: 'vendormanagement',
    component: VendorManagement
  },
  {
    path: '/openvouchers',
    name: 'openvouchers',
    component: OpenVouchers
  },
  {
    path: '/voucher-tracking',
    name: 'vouchertracking',
    component: VoucherTracking
  },
  {
    path: '/voucher-archiv',
    name: 'voucherarchive',
    component: VoucherArchive
  }
];

const router = new Router({
  routes,
});

export default router;

// TODO Fateh: wird das gebraucht?
// //  This is a guard
// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login'];
//   let authRequired;
//   let loggedIn;
//   if (from.path == "/login") {
//     authRequired = false;
//     loggedIn = true;
//   } else {
//     authRequired = !publicPages.includes(to.path);
//     loggedIn = localStorage.getItem('user');
//   }

//   //const authRequired = false;
//   //const loggedIn = true;

//   if (authRequired && !loggedIn) {
//     next('/login');
//   }

//   next();
// });
